import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { FaLeaf, FaShoppingCart } from 'react-icons/fa';
import { microgreensData } from '../data/products';
import productStyles from './ProductList.module.css';

function ProductList({ addToCart }) {
  const filteredProducts = microgreensData.filter(product => product.isAvailable);
  const blends = filteredProducts.filter(p => p.isBlend);
  const singles = filteredProducts.filter(p => !p.isBlend);

  const handleAddToCart = (product) => {
    const cartItem = {
      ...product,
      id: Date.now() + Math.random(), // Ensure unique ID
      totalPrice: product.price
    };
    addToCart(cartItem);
  };

  const renderCard = (product) => (
    <div key={product.id} className={productStyles.blendCard} role="listitem">
      <div className={productStyles.blendHeader}>
        <span className={productStyles.blendEmoji} aria-hidden="true">{product.emoji}</span>
        <Link to={`/product/${product.id}`} className={productStyles.nameLink}>
          <h3 className={productStyles.blendName}>{product.name}</h3>
        </Link>
        <p className={productStyles.blendSubtitle}>{product.subtitle}</p>
      </div>
      <p className={productStyles.blendIngredients}>
        {product.ingredients.join(' • ')}
      </p>
      <ul className={productStyles.blendBullets}>
        {product.bullets.map((b, i) => (
          <li key={i}>{b}</li>
        ))}
      </ul>
      <div className={productStyles.priceSection}>
        <span className={productStyles.price}>${product.price.toFixed(2)}</span>
        <button
          className={productStyles.addToCartBtn}
          onClick={() => handleAddToCart(product)}
          aria-label={`Add ${product.name} to cart`}
        >
          <FaShoppingCart className={productStyles.cartIcon} />
          Add to Cart
        </button>
      </div>
    </div>
  );

  return (
    <div className={productStyles.container} role="main">
      <Helmet>
        <title>Our Microgreens | Folsom Microgreens</title>
        <meta
          name="description"
          content="Explore our selection of premium, locally grown microgreens. Available for business orders and at local farmers markets."
        />
      </Helmet>

      {blends.length > 0 && (
        <section className={productStyles.section}>
          <div className={productStyles.sectionHeader}>
            <FaLeaf className={productStyles.sectionIcon} />
            <h2 className={productStyles.sectionTitle}>Our Blends</h2>
            <p className={productStyles.tagline}>
              Choose your greens based on taste — from mild and fresh to bold and peppery.
            </p>
          </div>
          <div className={productStyles.blendGrid}>
            {blends.map(renderCard)}
          </div>
        </section>
      )}

      {singles.length > 0 && (
        <section className={productStyles.section}>
          <div className={productStyles.sectionHeader}>
            <FaLeaf className={productStyles.sectionIcon} />
            <h2 className={productStyles.sectionTitle}>Single Greens</h2>
            <p className={productStyles.tagline}>
              One variety per pack — pick the flavor you want and build your own combination.
            </p>
          </div>
          <div className={productStyles.blendGrid}>
            {singles.map(renderCard)}
          </div>
        </section>
      )}

      {filteredProducts.length === 0 && (
        <div className={productStyles.noProducts}>
          No products available at this time.
        </div>
      )}
    </div>
  );
}

export default ProductList;